import { c as _c } from "react/compiler-runtime";
import React from 'react';
import classNames from 'classnames';
import { useClpPurchaseContext } from '../../context/clp-purchase-context.react-component';
import styles from './course-sidebar-container.module.scss';
import { BuyBox } from '../buy-box/buy-box.react-component';
import { useClpCourse } from '@/features/course-landing-page/context/clp-course-provider.react-component';
import { EnrollmentBox } from '@/features/course-landing-page/components/enrollment-box';
import { EnrolledBox } from '@/features/course-landing-page/components/enrolled-box';
import { GrowWithGoogleEnrollmentBox } from '@/features/course-landing-page/components/grow-with-google-enrollment-box';
import { CourseContentPlacement } from '@/features/course-landing-page/course-landing-page.react-component';
import { useUserHasOrganization } from "@/lib/hooks/use-user-has-organization";
interface CourseSidebarNoTabsContainerProps {
  placement: CourseContentPlacement;
}

/**
 * CourseSidebarNoTabsContainer component - this renders for enrolled, free, non-Personal Plan paid courses, and Grow with Google subscription courses
 */
export function CourseSidebarNoTabsContainer(t0) {
  const $ = _c(12);
  const {
    placement
  } = t0;
  const course = useClpCourse();
  const hasOrganization = useUserHasOrganization();
  const {
    isCourseIncludedInUserSubscription,
    isCourseIncludedInGrowWithGoogleSubscription,
    isEnrolledInCourse
  } = useClpPurchaseContext();
  const t1 = placement === CourseContentPlacement.SIDEBAR;
  let t2;
  if ($[0] !== t1) {
    t2 = classNames(styles.container, {
      [styles["sidebar-container"]]: t1
    });
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== course || $[3] !== hasOrganization || $[4] !== isCourseIncludedInGrowWithGoogleSubscription || $[5] !== isCourseIncludedInUserSubscription || $[6] !== isEnrolledInCourse || $[7] !== placement) {
    t3 = isCourseIncludedInGrowWithGoogleSubscription && !isCourseIncludedInUserSubscription ? <GrowWithGoogleEnrollmentBox placement={placement} /> : isCourseIncludedInUserSubscription || course.isFree && !isEnrolledInCourse || hasOrganization ? <EnrollmentBox placement={placement} /> : isEnrolledInCourse ? <EnrolledBox placement={placement} /> : <BuyBox placement={placement} />;
    $[2] = course;
    $[3] = hasOrganization;
    $[4] = isCourseIncludedInGrowWithGoogleSubscription;
    $[5] = isCourseIncludedInUserSubscription;
    $[6] = isEnrolledInCourse;
    $[7] = placement;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}